import type { Page } from '../../types';
import { REPORTING_PERIOD } from './shared_variables';

const recruitementActivity: Page[] = [
  {
    pageType: 'question',
    title: 'Recruitment activity',
    name: 'recruitment-activity',
    hidePageTitle: true,
    description: `<b>Heading figures for the number of individuals recruited externally between ${REPORTING_PERIOD}</b><br>
                      The data provided in this section should include numbers from any arm's length bodies, if these numbers relate to the appointment of civil servants or the advertisement of civil service vacancies.`,
    questions: [
      {
        questionType: 'textInput',
        title: 'Total number through fair and open competitions',
        name: 'headline-fair-and-open',
        // detailsHeading: 'More information',
        detailsContent: 'Fair and Open',
        rules: {
          required: true,
          number: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Total number of exceptions',
        name: 'headline-exceptions',
        // detailsHeading: 'More information',
        detailsContent: 'Exceptions',
        rules: {
          required: true,
          number: true,
        },
      },
    ],
  },
];
export default recruitementActivity;
